import { createActionsHook } from 'src/lib/sweetState';

import { CustomerMemberStore } from './CustomerMemberStore';

export const useCustomerMemberActions = createActionsHook(CustomerMemberStore);
